import { state, getters, mutations, actions } from './store';

export const name = '$_operationsMessage';
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
